<template>
    <div
        class="gs-toolbar"
        role="menu"
        @click.stop="onSelect"
    >
        {{ displayName }}
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { SET_SELECTED_ELEMENT, TOGGLE_GUIDED_SELECT } from '@/store/types/mutation-types';

export default {
    name: 'toolbar-guided-select',

    props: {
        displayName: {
            type: String,
            required: true,
        },

        element: {
            type: Object,
            required: true,
        },
    },

    methods: {
        ...mapMutations({
            setSelectedElement: SET_SELECTED_ELEMENT,
            toggleGuidedSelect: TOGGLE_GUIDED_SELECT,
        }),

        onSelect() {
            this.setSelectedElement({ element: this.element });
        },
    },
};
</script>

<style lang="scss">
.gs-toolbar {
    // the doubled-selector is needed to beat the !important on any Tailwind classes
    &.gs-toolbar {
        padding: 2px 20px 3px;
        font-size: 13px;
        font-weight: 700;
        color: var(--elementToolbar-color);
        background-color: var(--elementToolbar-backgroundColor);
        border-top: 2px solid var(--elementToolbar-borderColor);
        position: absolute;
        bottom: 100%;
        transform: translateY(-2px);
        left: -2px;
        text-align: center;
        letter-spacing: normal;
        z-index: 40;
        white-space: nowrap;

        &:hover {
            cursor: pointer;
        }
    }
}
</style>
